const ROUTES = Object.freeze({
  Home: "/home",
  itinerary: "/itinerary",
  Dining: "/dining",
  Dinner: "/dining/dinner",
  Lunch: "/dining/lunch",
  Breakfast: "/dining/breakfast",
  Golf: "/golf",
  Activities: "/activities",
  Activity: "/activities/activity",
  Spas: "/spa",
  Spa: "/spa/availability",
  "group-booking": "/dining/group",
  HotelMapImage: "/hotel-map",
  GiftCards: "/gift-cards",
  ESPWellness: "/wellness",
});

module.exports = {
  ROUTES,
}